// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-color {
    background-color: #f7f7f7;
    box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
    padding: 20px 30px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    width: 100%;
    margin-top: 30px;
}

.footer-container {
    width: 100%;
    max-width: 95%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
}

.footer-logos {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    width: 100%;
}

.footer-row {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 40px;
    flex-wrap: wrap;
    width: 100%;
}

/* Linhas com diferentes quantidades de logos */

.footer-row-5 {
    gap: 25px;
}

/* Para 5 logos */
.footer-row-6 {
    gap: 20px;
}

.footer-row-8 {
    gap: 10px;
}

.footer-logo img {
    height: 50px;
    width: auto;
    transition: transform 0.3s ease;
    image-rendering: -webkit-optimize-contrast;
    image-rendering: crisp-edges;
}

.footer-logo img:hover {
    transform: scale(1.05);
}

.footer-logo-small img {
    height: 45px;
    max-height: 45px;
}

.footer-logo-medium img {
    height: 65px;
    max-height: 65px;
}

.footer-logo-large img {
    height: 100px;
    max-height: 100px;
}

.footer-logo-xlarge img {
    height: 130px;
    max-height: 130px;
}

.footer-logo-xxlarge img {
    height: 160px;
    max-height: 160px;
}

.footer-divider {
    width: 100%;
    height: 1px;
    background-color: #ccc;
    margin-top: 10px;
}

.footer-copy {
    color: #666;
    font-size: 14px;
    text-align: center;
    padding-top: 10px;
}

.footer-label {
    text-align: center;
    font-size: 1.5rem;
    color: #333;
    margin-bottom: 8px;
    margin-top: 18px;
    letter-spacing: 1px;
}

/* ===== NOVOS ESTILOS PARA FAIXA DE PARTICIPANTES ===== */
/* Adicionados sem modificar os estilos existentes */

.faixa-participantes {
    background-color: rgba(0, 0, 0, 0.03);
    padding: 25px;
    margin-bottom: 25px;
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    width: 100%;
    box-sizing: border-box;
}

.grupo-participantes {
    margin-bottom: 20px;
}

.grupo-participantes:last-child {
    margin-bottom: 0;
}

.titulo-empresa {
    font-size: 1.3rem;
    color: #333;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 2px solid rgba(0, 0, 0, 0.1);
    font-weight: 600;
}

.lista-participantes {
    display: flex;
    flex-wrap: wrap;
    gap: 12px 20px;
    justify-content: flex-start;
}

.nome-participante {
    color: #555;
    font-size: 14px;
    padding: 6px 12px;
    background-color: rgba(0, 0, 0, 0.05);
    border-radius: 6px;
    border: 1px solid rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
}

.nome-participante:hover {
    background-color: rgba(0, 0, 0, 0.08);
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}


.footer-contato {
    text-align: center;
    padding: 15px 0;
    border-top: 1px solid rgba(255, 255, 255, 0.2);
    margin-top: 20px;
}

.contato-info {
    color:#333;
    font-size: 16px;
}

.contato-info strong {
    color:#333;
}

.contato-info span {
    margin-left: 5px;
}


@media (max-width: 480px) {
    .faixa-participantes {
        padding: 15px 10px;
    }

    .lista-participantes {
        gap: 8px 12px;
    }

    .nome-participante {
        font-size: 12px;
        padding: 4px 8px;
    }
}

@media (max-width: 768px) {

    .faixa-participantes {
        padding: 20px 15px;
        margin-bottom: 20px;
    }

    .titulo-empresa {
        font-size: 1.1rem;
        text-align: center;
    }

    .lista-participantes {
        justify-content: center;
        gap: 10px 15px;
    }

    .nome-participante {
        font-size: 13px;
        padding: 5px 10px;
        font-weight: bold;
    }

    .footer-contato {
        padding: 10px 0;
    }

    .contato-info {
        font-size: 14px;
    }

    .footer-logo img {
        height: 40px;
    }

    .footer-row {
        gap: 20px;
    }

    .footer-row-2 {
        gap: 40px;
    }

    .footer-row-3 {
        gap: 25px;
    }

    .footer-row-4 {
        gap: 20px;
    }

    .footer-row-5 {
        gap: 15px;
    }

    .footer-container {
        padding: 0 10px;
        max-width: 100%;
    }

    .footer-logo-small img {
        height: 1.8rem;
        max-height: 1.8rem;
    }

    .footer-logo-medium img {
        height: 2.7rem;
        max-height: 2.7rem;
    }

    .footer-logo-large img {
        height: 4rem;
        max-height: 4rem;
    }

    .footer-logo-xlarge img {
        height: 5.2rem;
        max-height: 5.2rem;
    }

    .footer-logo-small img {
        height: 1.8rem;
        max-height: 1.8rem;
    }

    .footer-logo-medium img {
        height: 2.7rem;
        max-height: 2.7rem;
    }

    .footer-logo-large img {
        height: 4rem;
        max-height: 4rem;
    }

    .footer-logo-xlarge img {
        height: 5.2rem;
        max-height: 5.2rem;
    }

    .footer-logo-xxlarge img {
        height: 6.5rem;
        max-height: 6.5rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/footerColaboradores/FooterColaboradores.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,yCAAyC;IACzC,kBAAkB;IAClB,4DAA4D;IAC5D,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,WAAW;AACf;;AAEA,+CAA+C;;AAE/C;IACI,SAAS;AACb;;AAEA,iBAAiB;AACjB;IACI,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,+BAA+B;IAC/B,0CAA0C;IAC1C,4BAA4B;AAChC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,0DAA0D;AAC1D,oDAAoD;;AAEpD;IACI,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,oCAAoC;IACpC,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,2CAA2C;IAC3C,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,qCAAqC;IACrC,kBAAkB;IAClB,qCAAqC;IACrC,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;IACrC,2BAA2B;IAC3B,wCAAwC;AAC5C;;;AAGA;IACI,kBAAkB;IAClB,eAAe;IACf,8CAA8C;IAC9C,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA;;IAEI;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,uBAAuB;QACvB,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,kBAAkB;IACtB;AACJ","sourcesContent":[".footer-color {\n    background-color: #f7f7f7;\n    box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);\n    padding: 20px 30px;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    width: 100%;\n    margin-top: 30px;\n}\n\n.footer-container {\n    width: 100%;\n    max-width: 95%;\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 15px;\n}\n\n.footer-logos {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 20px;\n    width: 100%;\n}\n\n.footer-row {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 40px;\n    flex-wrap: wrap;\n    width: 100%;\n}\n\n/* Linhas com diferentes quantidades de logos */\n\n.footer-row-5 {\n    gap: 25px;\n}\n\n/* Para 5 logos */\n.footer-row-6 {\n    gap: 20px;\n}\n\n.footer-row-8 {\n    gap: 10px;\n}\n\n.footer-logo img {\n    height: 50px;\n    width: auto;\n    transition: transform 0.3s ease;\n    image-rendering: -webkit-optimize-contrast;\n    image-rendering: crisp-edges;\n}\n\n.footer-logo img:hover {\n    transform: scale(1.05);\n}\n\n.footer-logo-small img {\n    height: 45px;\n    max-height: 45px;\n}\n\n.footer-logo-medium img {\n    height: 65px;\n    max-height: 65px;\n}\n\n.footer-logo-large img {\n    height: 100px;\n    max-height: 100px;\n}\n\n.footer-logo-xlarge img {\n    height: 130px;\n    max-height: 130px;\n}\n\n.footer-logo-xxlarge img {\n    height: 160px;\n    max-height: 160px;\n}\n\n.footer-divider {\n    width: 100%;\n    height: 1px;\n    background-color: #ccc;\n    margin-top: 10px;\n}\n\n.footer-copy {\n    color: #666;\n    font-size: 14px;\n    text-align: center;\n    padding-top: 10px;\n}\n\n.footer-label {\n    text-align: center;\n    font-size: 1.5rem;\n    color: #333;\n    margin-bottom: 8px;\n    margin-top: 18px;\n    letter-spacing: 1px;\n}\n\n/* ===== NOVOS ESTILOS PARA FAIXA DE PARTICIPANTES ===== */\n/* Adicionados sem modificar os estilos existentes */\n\n.faixa-participantes {\n    background-color: rgba(0, 0, 0, 0.03);\n    padding: 25px;\n    margin-bottom: 25px;\n    border-radius: 8px;\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.grupo-participantes {\n    margin-bottom: 20px;\n}\n\n.grupo-participantes:last-child {\n    margin-bottom: 0;\n}\n\n.titulo-empresa {\n    font-size: 1.3rem;\n    color: #333;\n    margin-bottom: 12px;\n    padding-bottom: 8px;\n    border-bottom: 2px solid rgba(0, 0, 0, 0.1);\n    font-weight: 600;\n}\n\n.lista-participantes {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px 20px;\n    justify-content: flex-start;\n}\n\n.nome-participante {\n    color: #555;\n    font-size: 14px;\n    padding: 6px 12px;\n    background-color: rgba(0, 0, 0, 0.05);\n    border-radius: 6px;\n    border: 1px solid rgba(0, 0, 0, 0.08);\n    transition: all 0.3s ease;\n}\n\n.nome-participante:hover {\n    background-color: rgba(0, 0, 0, 0.08);\n    transform: translateY(-1px);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n\n.footer-contato {\n    text-align: center;\n    padding: 15px 0;\n    border-top: 1px solid rgba(255, 255, 255, 0.2);\n    margin-top: 20px;\n}\n\n.contato-info {\n    color:#333;\n    font-size: 16px;\n}\n\n.contato-info strong {\n    color:#333;\n}\n\n.contato-info span {\n    margin-left: 5px;\n}\n\n\n@media (max-width: 480px) {\n    .faixa-participantes {\n        padding: 15px 10px;\n    }\n\n    .lista-participantes {\n        gap: 8px 12px;\n    }\n\n    .nome-participante {\n        font-size: 12px;\n        padding: 4px 8px;\n    }\n}\n\n@media (max-width: 768px) {\n\n    .faixa-participantes {\n        padding: 20px 15px;\n        margin-bottom: 20px;\n    }\n\n    .titulo-empresa {\n        font-size: 1.1rem;\n        text-align: center;\n    }\n\n    .lista-participantes {\n        justify-content: center;\n        gap: 10px 15px;\n    }\n\n    .nome-participante {\n        font-size: 13px;\n        padding: 5px 10px;\n        font-weight: bold;\n    }\n\n    .footer-contato {\n        padding: 10px 0;\n    }\n\n    .contato-info {\n        font-size: 14px;\n    }\n\n    .footer-logo img {\n        height: 40px;\n    }\n\n    .footer-row {\n        gap: 20px;\n    }\n\n    .footer-row-2 {\n        gap: 40px;\n    }\n\n    .footer-row-3 {\n        gap: 25px;\n    }\n\n    .footer-row-4 {\n        gap: 20px;\n    }\n\n    .footer-row-5 {\n        gap: 15px;\n    }\n\n    .footer-container {\n        padding: 0 10px;\n        max-width: 100%;\n    }\n\n    .footer-logo-small img {\n        height: 1.8rem;\n        max-height: 1.8rem;\n    }\n\n    .footer-logo-medium img {\n        height: 2.7rem;\n        max-height: 2.7rem;\n    }\n\n    .footer-logo-large img {\n        height: 4rem;\n        max-height: 4rem;\n    }\n\n    .footer-logo-xlarge img {\n        height: 5.2rem;\n        max-height: 5.2rem;\n    }\n\n    .footer-logo-small img {\n        height: 1.8rem;\n        max-height: 1.8rem;\n    }\n\n    .footer-logo-medium img {\n        height: 2.7rem;\n        max-height: 2.7rem;\n    }\n\n    .footer-logo-large img {\n        height: 4rem;\n        max-height: 4rem;\n    }\n\n    .footer-logo-xlarge img {\n        height: 5.2rem;\n        max-height: 5.2rem;\n    }\n\n    .footer-logo-xxlarge img {\n        height: 6.5rem;\n        max-height: 6.5rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
